// extracted by mini-css-extract-plugin
export default {"search-wrapper":"t5I3TJ","search":"dPlN1y"};